<template>
  <div class="fixed inset-0 z-50 overflow-hidden">
    <div
      class="absolute inset-0 bg-black bg-opacity-50"
      @click="$emit('close')"
    ></div>

    <div
      class="absolute inset-x-0 bottom-0 bg-white dark:bg-gray-800 rounded-t-2xl shadow-xl max-h-[90vh] flex flex-col"
    >
      <div
        class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700"
      >
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          Checkout
        </h2>
        <button
          @click="$emit('close')"
          class="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-4 space-y-4">
        <div
          v-if="pos.selectedPosInvoice?.invoice.customer"
          class="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg"
        >
          <p class="text-sm text-blue-600 dark:text-blue-400 mb-1">Customer</p>
          <p class="font-semibold text-gray-900 dark:text-white">
            {{ pos.selectedPosInvoice.invoice.customer.name }}
          </p>
          <p class="text-sm text-gray-600 dark:text-gray-400">
            {{ pos.selectedPosInvoice.invoice.customer.mobile }}
          </p>
        </div>

        <div
          class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 space-y-3"
        >
          <div>
            <search-select
              v-model="sales_reps_id"
              label="Sales Rep"
              :options="salesReps"
              placeholder="Select Sales Rep"
            />
          </div>

          <div>
            <text-input
              v-model="customer_reference"
              label="Customer Ref."
              placeholder="Enter reference number"
            />
          </div>

          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <CheckInput
                v-model="issue_kot"
                label=""
                :readonly="
                  isEmpty(pos.selectedPosInvoice?.invoice.customers_id) ||
                  (pos.selectedPosInvoice?.invoice?.customer?.addresses
                    ?.length ?? 0) <= 0
                "
              />
              <label
                class="text-sm font-medium text-gray-700 dark:text-gray-300"
                >Issue KOT</label
              >
            </div>
            <div class="flex items-center gap-2">
              <CheckInput
                v-model="to_delviery"
                label=""
                :readonly="
                  isEmpty(pos.selectedPosInvoice?.invoice.customers_id) ||
                  (pos.selectedPosInvoice?.invoice?.customer?.addresses
                    ?.length ?? 0) <= 0
                "
              />
              <label
                class="text-sm font-medium text-gray-700 dark:text-gray-300"
                >Track Delivery</label
              >
            </div>
          </div>
        </div>

        <div class="bg-gray-50 dark:bg-gray-700 rounded-lg p-4">
          <h3 class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
            Order Summary
          </h3>
          <div class="space-y-2">
            <div
              v-for="item in pos.selectedPosInvoice?.invoice.items || []"
              :key="item.id"
              class="flex justify-between text-sm"
            >
              <span class="text-gray-600 dark:text-gray-400"
                >{{ item.name }} x {{ item.quantity }}</span
              >
              <span class="font-medium text-gray-900 dark:text-white"
                >${{ (item.price * item.quantity).toFixed(2) }}</span
              >
            </div>
            <div
              class="pt-2 border-t border-gray-200 dark:border-gray-600 flex justify-between"
            >
              <span class="font-semibold text-gray-900 dark:text-white"
                >Total</span
              >
              <span class="text-xl font-bold text-blue-600 dark:text-blue-400"
                >${{ formatCurrency(pos.net_total) }}</span
              >
            </div>
          </div>
        </div>

        <div
          class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4"
        >
          <label
            class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-3"
          >
            Add Payment
          </label>

          <div class="grid grid-cols-2 gap-2 mb-4">
            <button
              v-for="type in payment_types"
              :key="type.id"
              @click="handleSelectType(type)"
              class="flex-1 p-4 rounded-lg border-2 transition-colors flex flex-col items-center gap-2 min-w-[150px]"
              :class="[
                selectedType.id === type.id
                  ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/50'
                  : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800',
                payments.some((p) => p.payment_type?.id === type.id)
                  ? 'opacity-50 cursor-not-allowed'
                  : '',
              ]"
              :disabled="
                payments.some((p) => p.payment_type?.id === type.id) ||
                (type.require_customer &&
                  (pos.selectedPosInvoice?.invoice.customers_id == '' ||
                    (type.check_credit &&
                      isEmpty(
                        pos.selectedPosInvoice?.invoice.customer
                          ?.credit_terms_id
                      )) ||
                    (type.check_credit &&
                      Number(
                        pos.selectedPosInvoice?.invoice.customer?.outstanding ??
                          0
                      ) >
                        Number(
                          pos.selectedPosInvoice?.invoice.customer
                            ?.credit_limit ?? 0
                        ))))
              "
              :style="{
                cursor:
                  type.require_customer &&
                  (pos.selectedPosInvoice?.invoice.customers_id == '' ||
                    (type.check_credit &&
                      isEmpty(
                        pos.selectedPosInvoice?.invoice.customer
                          ?.credit_terms_id
                      )) ||
                    (type.check_credit &&
                      Number(
                        pos.selectedPosInvoice?.invoice.customer?.outstanding ??
                          0
                      ) >
                        Number(
                          pos.selectedPosInvoice?.invoice.customer
                            ?.credit_limit ?? 0
                        )))
                    ? 'not-allowed'
                    : 'pointer',
                backgroundColor:
                  type.require_customer &&
                  (pos.selectedPosInvoice?.invoice.customers_id == '' ||
                    (type.check_credit &&
                      isEmpty(
                        pos.selectedPosInvoice?.invoice.customer
                          ?.credit_terms_id
                      )) ||
                    (type.check_credit &&
                      Number(
                        pos.selectedPosInvoice?.invoice.customer?.outstanding ??
                          0
                      ) >
                        Number(
                          pos.selectedPosInvoice?.invoice.customer
                            ?.credit_limit ?? 0
                        )))
                    ? '#464646'
                    : 'inherit',
              }"
            >
              <async-image
                class-name="h-6"
                :allow-preview="false"
                :src="type.icon_image"
                :alt="type.name"
              />
              <span class="text-sm font-medium">{{ type.name }}</span>
              <template
                v-if="
                  type.require_customer &&
                  (pos.selectedPosInvoice?.invoice.customers_id == '' ||
                    (type.check_credit &&
                      isEmpty(
                        pos.selectedPosInvoice?.invoice.customer
                          ?.credit_terms_id
                      )) ||
                    (type.check_credit &&
                      Number(
                        pos.selectedPosInvoice?.invoice.customer?.outstanding ??
                          0
                      ) >
                        Number(
                          pos.selectedPosInvoice?.invoice.customer
                            ?.credit_limit ?? 0
                        )))
                "
              >
                <span
                  v-if="
                    type.check_credit &&
                    pos.selectedPosInvoice?.invoice.customers_id &&
                    isEmpty(
                      pos.selectedPosInvoice?.invoice.customer?.credit_terms_id
                    )
                  "
                  class="text-sm font-medium"
                  >Credit Not Allowed</span
                >
                <span
                  v-else-if="
                    type.check_credit &&
                    Number(
                      pos.selectedPosInvoice?.invoice.customer?.outstanding ?? 0
                    ) >
                      Number(
                        pos.selectedPosInvoice?.invoice.customer
                          ?.credit_limit ?? 0
                      )
                  "
                  class="text-sm font-medium"
                  >Credit Limit Exceeded</span
                >
                <span v-else class="text-sm font-medium"
                  >Customer Required</span
                >
              </template>
              <span v-else-if="type.shortcut" class="text-sm font-medium"
                >({{ type.shortcut }})</span
              >
            </button>
          </div>

          <input
            ref="amountInput"
            v-model="currentAmount"
            type="number"
            step="0.01"
            min="0"
            :max="selectedType.allow_over_tender ? undefined : remainingAmount"
            placeholder="Enter amount"
            class="w-[100%] px-4 py-2 text-right text-2xl font-bold text-gray-900 dark:text-white border border-gray-200 dark:border-gray-700 rounded-lg"
            @keyup.enter="addPayment"
          />

          <div v-if="selectedType && selectedType.require_attachment">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
            >
              Attachment <span class="text-red-500">*</span>
            </label>
            <div class="space-y-3">
              <file-upload
                label=""
                placeholder="Attachment"
                path="payment_receipts"
                ref="attachment"
                v-model="currentAttachment"
                v-if="selectedType.require_attachment"
                :ocr="selectedType.read_ocr"
                :ocr-length="selectedType.ocr_string_length"
                :ocr-match="selectedType.ocr_init_string"
                :currency="'MVR'"
                @ocrRead="hanldeOcrRead"
              />
              <TextInput
                label=""
                placeholder="Reference"
                ref="reference"
                v-model="currentReference"
                v-if="selectedType.require_reference"
              />
            </div>
          </div>

          <button
            @click="addPayment"
            ref="addPaymentButton"
            caption="Add Payment"
            className="py-2 px-4 mt-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="
              !currentAmount ||
              parseFloat(currentAmount) <= 0 ||
              (selectedType.require_reference && !currentReference) ||
              (selectedType.require_attachment && !currentAttachment) ||
              (selectedType.require_customer &&
                pos.selectedPosInvoice?.invoice.customers_id == '') ||
              (selectedType.check_credit &&
                Number(
                  pos.selectedPosInvoice?.invoice.customer?.credit_limit ?? 0
                ) < Number(currentAmount ?? 0))
            "
          >
            Add Payment
          </button>
        </div>
        <span v-if="parseFloat(currentAmount) <= 0"
          >Enter Amount for Payment</span
        >
        <span v-else-if="selectedType.require_reference && !currentReference"
          >Enter The reference to proceed</span
        >
        <span v-else-if="selectedType.require_attachment && !currentAttachment"
          >Select the Attachment to proceed</span
        >
        <span
          v-else-if="
            selectedType.require_customer &&
            pos.selectedPosInvoice?.invoice.customers_id == ''
          "
          >Select a Customer to Proceed</span
        >
        <span
          v-else-if="
            selectedType.check_credit &&
            Number(
              pos.selectedPosInvoice?.invoice.customer?.credit_limit ?? 0
            ) < Number(currentAmount ?? 0)
          "
          >Customer do not have enough Credit Limit</span
        >
      </div>

      <div
        v-if="payments.length > 0"
        class="bg-green-50 dark:bg-green-900/20 border-2 border-green-200 dark:border-green-800 rounded-lg p-4"
      >
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-semibold text-green-900 dark:text-green-100">
            Collected Payments
          </h3>
          <span
            class="text-xs font-bold text-green-700 dark:text-green-300 bg-green-200 dark:bg-green-800 px-2 py-1 rounded-full"
          >
            {{ formatCurrency(totalPaid) }}
          </span>
        </div>
        <div class="space-y-2">
          <div
            v-for="(payment, index) in payments"
            :key="index"
            class="flex items-center justify-between p-2.5 bg-white dark:bg-gray-800 rounded-lg border border-green-200 dark:border-green-800"
          >
            <div class="flex items-center space-x-2.5">
              <div
                class="w-9 h-9 flex items-center justify-center bg-blue-100 dark:bg-blue-900/30 rounded-full"
              >
                img
              </div>
              <div>
                <p
                  class="text-sm font-semibold text-gray-900 dark:text-white capitalize"
                >
                  {{ payment.payment_type?.name }}
                </p>
                <p
                  v-if="payment.reference"
                  class="text-xs text-gray-600 dark:text-gray-400"
                >
                  Ref: {{ payment.reference }}
                </p>
              </div>
            </div>
            <div class="flex items-center space-x-2.5">
              <span class="text-base font-bold text-gray-900 dark:text-white"
                >${{ formatCurrency(payment.amount) }}</span
              >
              <button
                @click="removePayment(index)"
                class="p-1.5 text-red-600 hover:bg-red-100 dark:hover:bg-red-900/20 rounded-lg transition-colors"
              >
                <svg
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div
          class="mt-3 pt-3 border-t-2 border-green-200 dark:border-green-800"
        >
          <div
            v-if="remainingAmount > 0"
            class="flex items-center justify-between"
          >
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >Remaining</span
            >
            <span class="text-lg font-bold text-orange-600 dark:text-orange-400"
              >${{ formatCurrency(remainingAmount) }}</span
            >
          </div>
          <div
            v-else-if="remainingAmount < 0"
            class="flex items-center justify-between"
          >
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300"
              >Change Due</span
            >
            <span class="text-lg font-bold text-green-700 dark:text-green-300"
              >${{ formatCurrency(Math.abs(remainingAmount)) }}</span
            >
          </div>
          <div v-else class="flex items-center justify-between">
            <span class="text-sm font-medium text-green-700 dark:text-green-300"
              >Fully Paid</span
            >
            <svg
              class="w-6 h-6 text-green-600 dark:text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="p-4 border-t border-gray-200 dark:border-gray-700 space-y-3">
        <div class="flex flex-wrap gap-3">
          <buttons
            caption="Share"
            icon="Share2"
            :display-text="true"
            @click="handleUpdate(false, true, false)"
            :disabled="totalPaid < (pos.net_total ?? 0)"
            className="px-4 py-4 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2 whitespace-nowrap"
          />
          <!--<Buttons
            caption="Update with Delivery"
            :display-text="true"
            icon="Truck"
            @click="handleUpdate(false, false, true)"
            :disabled="
              totalPaid < (pos.net_total ?? 0) ||
              isEmpty(pos.selectedPosInvoice?.invoice.customers_id) ||
              (pos.selectedPosInvoice?.invoice?.customer?.addresses?.length ??
          0) <= 0
            "
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2 whitespace-nowrap"
          />-->
          <Buttons
            caption="Update"
            :display-text="true"
            icon="Save"
            @click="handleUpdate()"
            :disabled="totalPaid < (pos.net_total ?? 0)"
            className="px-4 py-4 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2 whitespace-nowrap"
          />
          <Buttons
            caption="Print"
            :display-text="true"
            icon="ReceiptText"
            @click="handleUpdate(true)"
            :disabled="totalPaid < (pos.net_total ?? 0)"
            className="px-4 py-4 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2 whitespace-nowrap"
          />
          <Buttons
            caption="Print A4"
            :display-text="true"
            icon="Printer"
            @click="handleUpdate(true, false, false, '', false)"
            :disabled="totalPaid < (pos.net_total ?? 0)"
            className="px-4 py-4 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-2 whitespace-nowrap"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  nextTick,
  onMounted,
  onBeforeUnmount,
  watch,
} from "vue";
import Toast from "../../../../../services/Toast";
import {
  CashierDuty,
  PaymentReceipts,
  PaymentType,
  SalesDocument,
  SalesRep,
} from "../../../../../types/models";
import { User } from "../../../../../types/auth";
import { posStore } from "../../../../../stores/posStore";
import SearchSelect from "../../../../../components/ui/form/SearchSelect.vue";
import TextInput from "../../../../../components/ui/form/TextInput.vue";
import CheckInput from "../../../../../components/ui/form/CheckInput.vue";
import {
  isEmpty,
  printPDFBlob,
  sharePDFBlob,
} from "../../../../../utils/CommonFunctions";
import FileUpload from "../../../../../components/ui/form/FileUpload.vue";
import AsyncImage from "../../../../../components/ui/form/AsyncImage.vue";
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import MessageBox from "../../../../../services/MessageBox";
import { api } from "../../../../../api/Api";

const pos = posStore();

const props = defineProps<{
  payment_types: PaymentType[];
  delivery_staffs: User[];
  cashierDuty: CashierDuty | null;
  salesReps: SalesRep[];
  posSettings?: any;
}>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "new", data: any, tables: any[]): void;
  (e: "complete", paymentData: any): void;
  (e: "getDeliverys"): void;
}>();


const payments = ref<PaymentReceipts[]>([]);
const currentAmount = ref("");
const currentReference = ref("");
const currentAttachment = ref("");
const selectedType = ref<PaymentType>(
  props.payment_types && props.payment_types.length > 0
    ? props.payment_types[0]
    : ({} as PaymentType)
);
const amountInput = ref<HTMLInputElement | null>(null);

const totalPaid = computed(() => {
  return roundToDecimalPlace(
    payments.value.reduce((sum, payment) => sum + payment.amount, 0)
  );
});

function roundToDecimalPlace(number: number, decimalPlaces = 2) {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
}

const remainingAmount = computed(() => {
  return roundToDecimalPlace((pos.net_total ?? 0) - totalPaid.value);
});

const change = computed(() => {
  return roundToDecimalPlace(totalPaid.value - (pos.net_total ?? 0));
});

const addPayment = () => {
  const amount = parseFloat(currentAmount.value);
  if (!amount || amount <= 0) return;

  if (!selectedType.value.allow_over_tender && amount > remainingAmount.value) {
    return;
  }

  if (selectedType.value.require_reference && !currentReference.value) {
    MessageBox.show("Reference is required", "warning");
    return;
  }

  if (selectedType.value.require_attachment && !currentAttachment.value) {
    MessageBox.show("Attachment is required", "warning");
    return;
  }

  let pay: PaymentReceipts = {
    id: "",
    date_time: new Date().toISOString().split("T")[0],
    prefix: "",
    suffix: "",
    ref_no: "",
    payment_types_id: selectedType.value.id,
    payment_type: selectedType.value,
    currencys_id: 1,
    currency: "",
    exchange_rate: 0,
    amount: amount,
    tendered: amount,
    change: change.value,
    outlets_id: "",
    outlet_pos_stations_id: "",
    cashier_dutys_id: undefined, //TODO: Get Cashier Duty
    customers_id: "",
    shift_end_reports_id: "",
    attachment: currentAttachment.value,
    reference: currentReference.value,
    status_id: "",
    users_id: "",
    uid: "",
  };

  nextTick(() => {
    console.log(selectedType.value);
    //if (selectedType.value.allow_over_tender == true) {
    const rem = (pos.net_total ?? 0) - totalPaid.value;
    console.log(
      "amount",
      amount,
      "remaining",
      remainingAmount.value,
      "rem",
      rem
    );
    if (remainingAmount.value < 0) {
      console.log("exceeding amount");
      pay.amount = amount + rem;
    } else {
      pay.amount = parseFloat(amount.toFixed(2));
    }
    /*pay.amount = parseFloat(
        (
          parseFloat(pay.amount?.toString() ?? "0") -
          parseFloat(change.value?.toString() ?? "0")
        ).toFixed(2)
      );*/
    pay.change = change.value;
    // }
  });
  console.log("pay", pay);
  payments.value.push(pay);
  currentAmount.value = "";
  currentReference.value = "";
  currentAttachment.value = "";
  selectedType.value = props.payment_types[0];

  console.log(payments.value);

  // Focus amount input after adding payment
};

const sales_reps_id = ref<string | number | null>(null);
const to_delviery = ref<boolean>(false);
const issue_kot = ref<boolean>(false);
const customer_reference = ref<string>("");

const removePayment = (index: number) => {
  payments.value.splice(index, 1);
};

const endPoint = "revenue/sales/pos/";
const handleUpdate = async (
  print = false,
  share = false,
  delivery = false,
  delivery_staff: string | number = "",
  thermal = true
) => {

  if (totalPaid.value < (pos.net_total ?? 0)) return;

  let invoice: SalesDocument =
    pos.selectedPosInvoice?.invoice ?? ({} as SalesDocument);

  invoice.to_deliver = delivery;
  if (!delivery) {
    invoice.to_deliver = delivery_staff ? true : to_delviery.value ?? false;
  }

  invoice.delivery_staffs_id = delivery_staff;

  invoice.warehouses_id = props.posSettings.warehouse_id ?? "";
  invoice.outlets_id =  "";
  invoice.outlet_pos_stations_id =  "";
  invoice.price_lists_id = props.posSettings.price_list_id ?? "";
  invoice.sales_channels_id = props.posSettings.sales_channel_id ?? "";
  invoice.sales_reps_id = sales_reps_id.value ?? "";

  //console.log("delivery", delivery);
  //invoice.to_deliver = delivery;
  invoice.thermal = thermal;
  invoice.share = share || print;
  invoice.delivery = delivery;
  if (
    !invoice.delivery_address_id &&
    invoice.customer?.addresses &&
    invoice.customer.addresses.length > 0
  ) {
    invoice.delivery_address_id = invoice.customer?.addresses?.[0]?.id ?? "";
  }

  if (invoice.customer) {
    invoice.credit_terms_id = invoice.customer?.credit_terms_id ?? 1;
    // Set due_date to 10 days from now
    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + (invoice.customer?.credit_days ?? 0));
    invoice.due_date = dueDate.toISOString().split("T")[0];
  }

  invoice.payments = payments.value;
  invoice.cashier_dutys_id = props.cashierDuty ? props.cashierDuty.id : "";

  invoice.left_margin =  0;
  invoice.right_margin =  0;
  invoice.top_margin =  0;
  invoice.button_margin =  0;
  invoice.font_size =  0;
  invoice.font_bold =  false;
  invoice.recepit_size =  80;
  invoice.print_barcode =  true;
  invoice.customer_reference = customer_reference.value;

  const response = await api.post(endPoint + "invoice", invoice);
  if (response.success == true) {
    Toast.show("Invoice Created", "info");
    emit("close");
    emit("new", response.data.data, response.data.tables);
    if (print) {
      printPDFBlob(response.data.file);
    }
    if (share) {
      sharePDFBlob(response.lists, "Bill #:" + response.data.data.document_no);
    }
    if (delivery) {
      emit("getDeliverys");
    }
    //printInvoice(response.data, props.posStation);
    pos.voidInvoice();
  } else {
    Toast.show("Could not update Invoice", "warning");
  }

  emit("complete", {
    payments: payments.value,
    totalPaid: totalPaid.value,
    change: change.value,
  });
};

const currencyCode = computed(() => {
  return "MVR";
});
const formatCurrency = (amount: number) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyCode.value,
  }).format(amount);
};

const scrollContainer = ref<HTMLElement | null>(null);
const isDragging = ref(false);
const startX = ref(0);
const scrollLeft = ref(0);

onMounted(() => {
  if (scrollContainer.value) {
    scrollContainer.value.addEventListener("mousedown", startDrag);
  }
  focusAmountInput();
});

onBeforeUnmount(() => {
  if (scrollContainer.value) {
    scrollContainer.value.removeEventListener("mousedown", startDrag);
  }
});

// Watch for payment type changes to focus amount input
watch(selectedType, () => {
  focusAmountInput();
});

const startDrag = (e: { pageX: number }) => {
  isDragging.value = true;
  if (scrollContainer.value) {
    startX.value = e.pageX - scrollContainer.value.offsetLeft;
    scrollLeft.value = scrollContainer.value.scrollLeft;
  }
  document.addEventListener("mousemove", onDrag);
  document.addEventListener("mouseup", stopDrag);
};

const onDrag = (e: { preventDefault: () => void; pageX: number }) => {
  if (!isDragging.value) return;
  e.preventDefault();
  if (!scrollContainer.value) return;
  const x = e.pageX - scrollContainer.value.offsetLeft;
  const walk = (x - startX.value) * 3; //scroll-fast
  scrollContainer.value.scrollLeft = scrollLeft.value - walk;
};

const stopDrag = () => {
  isDragging.value = false;
  document.removeEventListener("mousemove", onDrag);
  document.removeEventListener("mouseup", stopDrag);
};

const focusAmountInput = () => {
  // Use nextTick to ensure DOM is updated
  nextTick(() => {
    amountInput.value?.focus();
  });
};

const handleSelectType = (type: PaymentType) => {
  console.log("Selected payment type:", type);
  selectedType.value = type;
  currentAmount.value = "";
  currentReference.value = "";
  currentAttachment.value = "";
  focusAmountInput();
};

const hanldeOcrRead = (reference: string, amount: string, file: string) => {
  if (reference) currentReference.value = reference;
  if (amount) {
    currentAmount.value = amount;
  }
  if (file) currentAttachment.value = file;
  if (
    currentAmount.value &&
    currentReference.value &&
    currentAttachment.value
  ) {
    addPayment();
  }
};
</script>
